'use client';

import type { PropsWithChildren } from 'react';

import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { Toaster } from '@avodah-inc/ui';

import { EnvsProvider, type EnvsContextType } from '~/providers/envs-provider';

export const ClientProviders = ({
  envs,
  children,
}: PropsWithChildren<{ envs: EnvsContextType }>) => {
  return (
    <EnvsProvider envs={envs}>
      {process.env.NODE_ENV === 'development' && (
        <ReactQueryDevtools initialIsOpen={false} />
      )}
      <Toaster />
      {children}
    </EnvsProvider>
  );
};
